import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Campaigns from './pages/Campaigns';
import CampaignDetail from './pages/CampaignDetail';
import CampaignLauncher from './pages/CampaignLauncher';
import CreativeStudio from './pages/CreativeStudio';
import Products from './pages/Products';
import Reddit from './pages/Reddit';
import Funnels from './pages/Funnels';
import Recommendations from './pages/Recommendations';
import Onboarding from './pages/Onboarding';
import Billing from './pages/Billing';
import Copilot from './pages/Copilot';
import Competitors from './pages/Competitors';
import Benchmarks from './pages/Benchmarks';
import Operator from './pages/Operator';
import Channels from './pages/Channels';
import PixelSetup from './pages/PixelSetup';

export default function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        {/* Run */}
        <Route path="/" element={<Dashboard />} />
        <Route path="/copilot" element={<Copilot />} />
        <Route path="/campaigns" element={<Campaigns />} />
        <Route path="/campaigns/new" element={<CampaignLauncher />} />
        <Route path="/campaigns/:id" element={<CampaignDetail />} />
        <Route path="/creatives" element={<CreativeStudio />} />
        <Route path="/recommendations" element={<Recommendations />} />
        <Route path="/operator" element={<Operator />} />

        {/* Intelligence */}
        <Route path="/competitors" element={<Competitors />} />
        <Route path="/benchmarks" element={<Benchmarks />} />
        <Route path="/reddit" element={<Reddit />} />
        <Route path="/funnels" element={<Funnels />} />

        {/* Setup */}
        <Route path="/products" element={<Products />} />
        <Route path="/channels" element={<Channels />} />
        <Route path="/pixel" element={<PixelSetup />} />
        <Route path="/billing" element={<Billing />} />
        <Route path="/onboarding" element={<Onboarding />} />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
